import { generator } from '@philips-emr/tws-core/lib/client/event-listener';

const HPMSOnAfterSubmitAmountProfessionalsCard = generator('onAfterSubmitAmountProfessionalsCard');

export {
  HPMSOnAfterSubmitAmountProfessionalsCard,
};

